/**
 * County-to-city mapping data for internal linking hierarchy.
 * Used by county pages, breadcrumbs, ServiceAreas, and Footer.
 */

export interface CityEntry {
  name: string;
  slug: string;
}

export interface CountyEntry {
  name: string;
  slug: string;
  cities: CityEntry[];
}

export const counties: CountyEntry[] = [
  {
    name: 'Volusia County',
    slug: 'volusia-county',
    cities: [
      { name: 'Astor', slug: 'astor' },
      { name: 'Daytona Beach', slug: 'daytona-beach' },
      { name: 'DeBary', slug: 'debary' },
      { name: 'DeLand', slug: 'deland' },
      { name: 'DeLand Southwest', slug: 'deland-southwest' },
      { name: 'De Leon Springs', slug: 'de-leon-springs' },
      { name: 'Deltona', slug: 'deltona' },
      { name: 'Edgewater', slug: 'edgewater' },
      { name: 'Holly Hill', slug: 'holly-hill' },
      { name: 'Lake Helen', slug: 'lake-helen' },
      { name: 'Lake Mack Forest Hills', slug: 'lake-mack-forest-hills' },
      { name: 'New Smyrna Beach', slug: 'new-smyrna-beach' },
      { name: 'North DeLand', slug: 'north-deland' },
      { name: 'Oak Hill', slug: 'oak-hill' },
      { name: 'Orange City', slug: 'orange-city' },
      { name: 'Ormond Beach', slug: 'ormond-beach' },
      { name: 'Pierson', slug: 'pierson' },
      { name: 'Port Orange', slug: 'port-orange' },
      { name: 'South Daytona', slug: 'south-daytona' },
      { name: 'West DeLand', slug: 'west-deland' },
    ],
  },
  {
    name: 'Seminole County',
    slug: 'seminole-county',
    cities: [
      { name: 'Altamonte Springs', slug: 'altamonte-springs' },
      { name: 'Casselberry', slug: 'casselberry' },
      { name: 'Lake Mary', slug: 'lake-mary' },
      { name: 'Longwood', slug: 'longwood' },
      { name: 'Maitland', slug: 'maitland' },
      { name: 'Oviedo', slug: 'oviedo' },
      { name: 'Sanford', slug: 'sanford' },
      { name: 'Winter Springs', slug: 'winter-springs' },
    ],
  },
  {
    name: 'Orange County',
    slug: 'orange-county',
    cities: [
      { name: 'Apopka', slug: 'apopka' },
      { name: 'Isleworth', slug: 'isleworth' },
      { name: 'Ocoee', slug: 'ocoee' },
      { name: 'Orlando', slug: 'orlando' },
      { name: 'Winter Garden', slug: 'winter-garden' },
      { name: 'Winter Park', slug: 'winter-park' },
    ],
  },
  {
    name: 'Lake & Sumter Counties',
    slug: 'lake-sumter-county',
    cities: [
      { name: 'The Villages', slug: 'the-villages' },
    ],
  },
];

/**
 * Look up which county a city belongs to by its slug.
 */
export const getCountyForCity = (citySlug: string): CountyEntry | undefined => {
  return counties.find(county =>
    county.cities.some(city => city.slug === citySlug)
  );
};

/**
 * Get all city slugs across all counties.
 */
export const getAllCitySlugs = (): string[] => {
  return counties.flatMap(county => county.cities.map(city => city.slug));
};
